import { render, staticRenderFns } from "./KontakPIC.vue?vue&type=template&id=0f9ffc38&"
import script from "./KontakPIC.vue?vue&type=script&lang=js&"
export * from "./KontakPIC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports